import React, { useEffect, useState } from "react";
import {
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Box,
  Paper,
  TablePagination,
} from "@mui/material";
import { UserTableHeaders } from "../../data/UsersPage";
import AlertMessage from "../common/AlertMessage";
import { getStorageValue } from "../../utils/helper";
import { useNavigate } from "react-router";
import UserListAPI from "../../utils/services/userList.api";
import "../../styles/ListingPageFilter.css";
import { ReactComponent as FilledStar } from "../../assets/logos/filled-star.svg";
import { ReactComponent as EmptyStar } from "../../assets/logos/empty-star.svg";
import { ReactComponent as OneRangeStar } from "../../assets/logos/one-range-star.svg";
import { ReactComponent as TwoRangeStar } from "../../assets/logos/two-range-star.svg";
import { ReactComponent as ThreeRangeStar } from "../../assets/logos/three-range-star.svg";
import { ReactComponent as FourRangeStar } from "../../assets/logos/four-range-star.svg";
import { ReactComponent as FiveRangeStar } from "../../assets/logos/five-range-star.svg";
import NoDataFound from "../common/NoDataFound";
import Loaders from "../common/Loaders";

const UserList = ({ searchParams, filterParams }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageCount, setPageCount] = useState(localStorage.getItem("PageSize") ? localStorage.getItem("PageSize") : 10);
  const [totalData, setTotalData] = useState(0);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const roleId = getStorageValue("roleId");
  const { fetchUserList } = UserListAPI;
  const [loading, setLoading] = useState(false);

  const getListingData = async () => {
    setLoading(true);
    const response = await fetchUserList(
      roleId,
      pageNumber,
      pageCount,
      searchParams,
      filterParams
    );
    if (response.status !== "success") {
      setLoading(false);
      setAlertSeverity(response.status);
      setAlertMessage(
        response?.error?.response?.data?.message
          ? response?.error?.response?.data?.message
          : response.message
      );
      setData(response?.data?.userList);
      setOpen(true);
    } else {
      setLoading(false);
      setData(response?.data?.userList);
      setTotalData(response?.data?.count);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePageChange = (e, newPage) => {
    setPageNumber(newPage + 1);
  };

  const handleRowsChange = (e) => {
    setPageCount(e.target.value);
    setPageNumber(1);
    localStorage.setItem("PageSize", e.target.value);
  };

  const handleRatingStar = (range) => {
    if (range === 0) {
      return <EmptyStar width={'20px'} height={'20px'} />;
    } else if (range === 5) {
      return <FilledStar width={'20px'} height={'20px'} />;
    } else if (range > 0 && range < 1) {
      return <OneRangeStar width={'20px'} height={'20px'} />;
    } else if (range >= 1 && range < 2) {
      return <TwoRangeStar width={'20px'} height={'20px'} />;
    } else if (range >= 2 && range < 3) {
      return <ThreeRangeStar width={'20px'} height={'20px'} />;
    } else if (range >= 3 && range < 4) {
      return <FourRangeStar width={'20px'} height={'20px'} />;
    } else if (range >= 4 && range < 5) {
      return <FiveRangeStar width={'20px'} height={'20px'} />;
    }
  };

  useEffect(() => {
    getListingData();
    // eslint-disable-next-line
  }, [roleId, pageNumber, searchParams, filterParams?.sortBy, pageCount]);

  const handleNavigate = (data) => {
    localStorage.setItem("SearchParams", "");
    localStorage.setItem("FilterParams", "");
    localStorage.setItem("SortByParams", "");
    localStorage.setItem("PageSize", "");
    navigate(`/users/${data?.userId}`, {state:{userData: data}});
  };

  return (
    <>
     {loading && (
        <Loaders />
      )}
      {!loading && <TableContainer component={Paper} sx={{ border: "1px solid #E4E7EC", maxHeight: "668px", minHeight: '600px'}}>
        <Table sx={{ minWidth: 650 }} stickyHeader aria-label="users table">
          <TableHead>
            <TableRow>
              {UserTableHeaders?.map((ele) => {
                return (
                  <>
                    {
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          fontWeight: "600",
                          padding: "12px",
                        }}
                      >
                        {ele}
                      </TableCell>
                    }
                  </>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, index) => (
              <TableRow
                onClick={() => handleNavigate(row)}
                key={index}
                sx={{
                  height: "55px",
                  backgroundColor: index % 2 === 0 ? "#FBFBFB" : "",
                }}
              >
                <TableCell
                  sx={{ fontSize: "12px", padding: "12px", fontWeight: 500 }}
                  component="th"
                  scope="col"
                >
                  <Box sx={{ width: "8rem", wordBreak: "break-word" }}>
                    {row?.firstName} {row?.lastName}
                  </Box>
                </TableCell>
                <TableCell
                  sx={{ fontSize: "12px", padding: "12px" }}
                  component="th"
                  scope="col"
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "3rem",
                    }}
                  >
                    <Box sx={{ marginTop: '4px'}}>{handleRatingStar(row?.rating)}</Box>
                    <Box sx={{ ml: "7px",fontWeight: 500 }}>{row?.rating}</Box>
                  </Box>
                </TableCell>
                <TableCell
                  sx={{ fontSize: "12px", padding: "12px", fontWeight: 500 }}
                  component="th"
                  scope="col"
                >
                  {row?.delivered}
                </TableCell>
                <TableCell
                  sx={{ fontSize: "12px", padding: "12px", fontWeight: 500 }}
                  component="th"
                  scope="col"
                >
                  {row?.requested}
                </TableCell>
                <TableCell
                  sx={{ fontSize: "12px", padding: "12px" }}
                  component="th"
                  scope="col"
                >
                  <Box sx={{ width: "15rem", wordBreak: "break-word" }}>
                    {row?.email}
                  </Box>
                </TableCell>
                <TableCell
                  sx={{ fontSize: "12px", padding: "12px" }}
                  component="th"
                  scope="col"
                >
                  <Box sx={{ width: "7rem" }}>
                    {row?.countryCode}{" "}
                    {row?.phoneNumber?.replace(
                      /(\d{3})(\d{3})(\d{4})/,
                      "$1-$2-$3"
                    )}
                  </Box>
                </TableCell>
                <TableCell
                  sx={{ fontSize: "12px", padding: "12px" }}
                  component="th"
                  scope="col"
                >
                  <Box sx={{ width: "9rem", wordBreak: "break-word" }}>
                    {row?.address}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            {!loading && data?.length === 0 && (
              <TableRow width="100%">
                <TableCell width="100%" colSpan={7} sx={{ padding: "10rem" }}>
                  <NoDataFound />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>}
      {!loading && <Box>
        <TablePagination
          component="div"
          count={totalData}
          page={pageNumber - 1}
          onPageChange={handlePageChange}
          rowsPerPage={pageCount}
          onRowsPerPageChange={handleRowsChange}
        />
      </Box>}

      <AlertMessage
        open={open}
        handleClose={handleClose}
        message={alertMessage}
        severity={alertSeverity}
      />
    </>
  );
};

export default React.memo(UserList);
